import {
  GET_USER_INFO,
  UPDATE_USER_TOKEN,
  GET_LOGIN_BOX_CLOSE,
  EMPTY_LOGIN_CLOSE,
} from '../constants/user';

export const updateUserInfo = userInfo => ({
  type: GET_USER_INFO,
  userInfo,
});

export const updateUserToken = userToken => ({
  type: UPDATE_USER_TOKEN,
  userToken,
});

export const getLoginClose = userToken => ({
  type: GET_LOGIN_BOX_CLOSE,
  userToken,
});

export const emptyLoginClose = userToken => ({
  type: EMPTY_LOGIN_CLOSE,
  userToken,
});
